import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import type { TabsProps } from './Tabs.types'

function Tabs(props: TabsProps) {
  const location = useLocation()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState(() => {
    const searchParams = new URLSearchParams(location.search)
    const tabFromUrl = searchParams.get('tab')

    return tabFromUrl || props.defaultTab
  })

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const tabFromUrl = searchParams.get('tab')
    setActiveTab(tabFromUrl || props.defaultTab)
  }, [location.search, props.defaultTab])

  const handleTabClick = (tabKey: string) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('tab', tabKey)
    const pathName =
      typeof location.pathname === 'string' ? location.pathname : '/'
    navigate(`${pathName}?${searchParams.toString()}`, { replace: true })
    props.onTabClick(tabKey)
  }

  return (
    <div className="tabs">
      <div className="border-b border-gray-300 mt-6">
        <ul className="flex gap-6 text-sm">
          {props.items.map((item) => (
            <li
              data-testid={item.key}
              key={item.key}
              className={`cursor-pointer ${
                item.key === activeTab
                  ? 'text-blue-600 border-b-2 border-blue-500 pb-2 font-medium'
                  : 'text-gray-600 hover:text-gray-800'
              }`}
              onClick={() => handleTabClick(item.key)}
            >
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default Tabs
